import React from 'react';

import { Route, Routes } from 'react-router-dom';
import withRouter from './components/global/withRouter';
import { isMobile } from 'react-device-detect';

import Splash from './components/splash/CLOSED_Splash';
import Splash2 from './components/splash/Splash';
import MobileWarning from './components/splash/MobileWarning';
import Root from './components/root/Root';
import SignIn from './components/signIn';
import Terms from './components/terms/Terms';
import Loader from './components/global/loader/Loader';
import ErrorPrompt from './components/global/ErrorPrompt';

const App = (props) => {
	if (isMobile) {
		document.body.className = 'bg2';
	}

	return (
		<div className={isMobile ? 'container mobile' : 'container'}>
			<Routes>
				{/* <Route path="/signin/*" element={<SignIn />} />
				<Route path="/logga-in/:code" element={<SignIn />} />
				<Route path="/registrera/:code" element={<SignIn />} />
				<Route path="/home/*" element={<Root />} />
				<Route path="/invited/:code?" element={<SignIn />} />
				<Route path="/terms" element={<Terms />} /> */}
				<Route path="*" element={<Splash />} />
				{/* <Route exact path="/9sda09jaijsod" element={<Splash2 />} /> */}
			</Routes>
			<Loader />
			<ErrorPrompt />
			{isMobile && (
				<div className="footer_logo_mobile">
					<figure />
				</div>
			)}
		</div>
	);
};

export default withRouter(App);
